import Main from './Main/Main';
import './App.css';


function App() {
  return (
    <>
    <Main/>
    </>
  );
}

export default App;
